module.exports = __webpack_public_path__ + "686f8efa6e3e28e96d1c08399e8d353d.svg";